import DOMPurify from 'dompurify'
import { forwardRef, useEffect, useRef } from 'react'
import { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { promotionalBannerVariants } from '@velasca/constants'
import { ArrowIcon } from '@velasca/icons/arrow'
import type { PromotionalBannerProps } from '@velasca/types'
import * as S from './styles'

const PromotionalBanner = forwardRef<
  HTMLDivElement | null,
  PromotionalBannerProps
>(({ messages, variant = promotionalBannerVariants.PRIMARY }, ref) => {
  useEffect(() => {
    const promotionalBannerSkeletonEl = document.querySelector<HTMLElement>(
      '#promotional-banner-skeleton',
    )

    if (promotionalBannerSkeletonEl) {
      promotionalBannerSkeletonEl.classList.add('react-loaded')
    }
  }, [])

  const navigationNextRef = useRef(null)
  const navigationPrevRef = useRef(null)

  if (!messages) {
    return null
  }

  const showNavigationButtons = messages.length > 1

  const messageElements = messages.map(({ text }) => {
    return (
      <SwiperSlide key={text}>
        <S.PromotionalBannerSlide>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(text, {
                ALLOWED_TAGS: ['b', 'a'],
                ALLOWED_ATTR: ['href', 'target', 'rel', 'style'],
              }),
            }}
          />
        </S.PromotionalBannerSlide>
      </SwiperSlide>
    )
  })

  return messageElements.length <= 0 ? null : (
    <S.PromotionalBannerBackground ref={ref} variant={variant}>
      <S.PromotionalBannerContainer
        showNavigationButtons={showNavigationButtons}
      >
        {showNavigationButtons ? (
          <button ref={navigationPrevRef}>
            <ArrowIcon />
          </button>
        ) : null}
        <Swiper
          loop={showNavigationButtons}
          modules={[Navigation]}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
        >
          {messageElements}
        </Swiper>

        {showNavigationButtons ? (
          <button ref={navigationNextRef}>
            <ArrowIcon />
          </button>
        ) : null}
      </S.PromotionalBannerContainer>
    </S.PromotionalBannerBackground>
  )
})

export default PromotionalBanner
